import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './InvoiceModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class InvoiceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: '',
        }
    }

    confirmInvoice = () => {
        let invoice = this.state.invoice;
        console.log('invoice', invoice)
        this.props.confirmInvoice(invoice);
        this.setState({
            invoice: '',
        });
    }

    handleChange = (e) => {
        let invoice = this.state.invoice;
        invoice = e.target.value;
        this.setState({
            invoice,
        });
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.isInvoiceModalOpen} toggle={() => this.props.toggleInvoiceModal()}>
                    <ModalHeader toggle={() => this.props.toggleInvoiceModal()}>{strings.title}</ModalHeader>
                    <ModalBody className="text-left">
                        <p>{strings.description}</p>
                        <div className="showtix-form__input">
                            <input
                                className="showtix-input"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.invoice}
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-2"
                            onClick={() => this.confirmInvoice()}
                            disabled={this.state.invoice === ''}
                        >
                            {strings.confirm}
                        </button>
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={() => this.props.toggleInvoiceModal()}
                        >{strings.cancel}</button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

InvoiceModal.propTypes = {
    isInvoiceModalOpen: PropTypes.bool,
    toggleInvoiceModal: PropTypes.func,
    confirmInvoice: PropTypes.func,
};

export default InvoiceModal;


// WEBPACK FOOTER //
// ./src/components/Payout/InvoiceModal/InvoiceModal.js